var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchVolumed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 7C10.5 8.933 8.933 10.5 7 10.5C5.067 10.5 3.5 8.933 3.5 7C3.5 5.067 5.067 3.5 7 3.5C8.933 3.5 10.5 5.067 10.5 7ZM9.45294 11.358C8.72824 11.7668 7.89136 12 7 12C4.23858 12 2 9.76142 2 7C2 4.23858 4.23858 2 7 2C9.76142 2 12 4.23858 12 7C12 7.89135 11.7668 8.72823 11.358 9.45292C11.6469 9.50141 11.9261 9.62716 12.1628 9.83137L14.2638 11.6435C15.0815 12.3488 15.1276 13.6004 14.364 14.364C13.6004 15.1276 12.3489 15.0815 11.6435 14.2637L9.8314 12.1629C9.62717 11.9261 9.50142 11.6469 9.45294 11.358ZM11.1831 10.9672L13.2841 12.7793C13.4416 12.9152 13.4504 13.1562 13.3034 13.3033C13.1563 13.4504 12.9152 13.4415 12.7794 13.284L10.9672 11.1831C10.9149 11.1224 10.9182 11.0316 10.9749 10.9749C11.0316 10.9182 11.1224 10.9149 11.1831 10.9672Z",
    fill: "#54687D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchVolumed);
export default __webpack_public_path__ + "static/media/search-volumed.34012b9fcd7c739fb80994d4630230ba.svg";
export { ForwardRef as ReactComponent };